<script lang="ts" setup>
withDefaults(
  defineProps<{
    color: string
    title?: string | null
  }>(),
  { title: null }
)
</script>

<template>
  <span class="inline-flex items-center justify-center" :class="color">
    <span class="box-border size-[1em] rounded-full" :style="{ backgroundColor: color }" />

    <span v-if="title" class="ml-1.5">{{ title }}</span>
  </span>
</template>
